import { z } from "zod";
import { DateOnly, Money } from "./common.ts";

export const ChargeInput = z.object({
  companyId: z.string().uuid(),
  kind: z.string().max(40),
  amount: Money,
  description: z.string().max(400),
  recurring: z.boolean().default(false),
});

export const InvoiceQuery = z.object({
  companyId: z.string().uuid().optional(),
  status: z.enum(["draft", "sent", "paid", "overdue", "failed"]).optional(),
});

export const LocInput = z.object({
  companyId: z.string().uuid(),
  templateKey: z.string().max(60).default("products"),
  /** blank: a numbered, snapshotted certificate whose text is the wording alone — the one place free text is printed (certificates.md → The blank certificate) */
  scope: z.enum(["products", "facility", "blank"]).default("products"),
  shownName: z.string().max(200).nullable().optional(),
  shownAddress: z.string().max(400).nullable().optional(),
  issueDate: DateOnly,
  validTo: DateOnly.nullable().optional(),
  productIds: z.array(z.string().uuid()).default([]),
  facilityId: z.string().uuid().nullable().optional(),
  wording: z.string().max(600).nullable().optional(),
  /** issuing offers to send in the same step (certificates.md → Sending): addresses to send the certificate to at issue */
  sendTo: z.array(z.string().email()).max(6).default([]),
});
export type LocInput = z.infer<typeof LocInput>;

export const LocVoidInput = z.object({ reason: z.string().min(1).max(2000) });
